import React, { Component } from "react";
import {
  HmgDropdown,
  SelectAll,
  HotelDropdown,
  HmgMainDropdown,
} from "../../../../components/HmgHotelDropdown";
import {
  hmgGet,
  hmgHotels,
  hmgmainGetHmgMain,
  projectGetHotels,
} from "../../../../store/actions";
import { Row, Checkbox, Form } from "antd";
// import PropTypes from 'prop-types'
import { connect } from "react-redux";
// import Form from 'antd/lib/form/Form'

const hmgStyles = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 8 },
    lg: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 12 },
    lg: { span: 10 },
  },
};

const hmgStylesWithoutMargin = {
  ...hmgStyles,
  style: { marginBottom: 0 },
};

const selectStyles = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16, offset: 8 },
    md: { span: 12, offset: 8 },
    lg: { span: 10, offset: 6 },
  },
  style: { marginBottom: 0 },
};

const hotelListStyles = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 8 },
    lg: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 12 },
    lg: { span: 10 },
  },
};

const repHotelStyles = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16, offset: 8 },
    md: { span: 12, offset: 8 },
    lg: { span: 10, offset: 6 },
  },
  style: { marginBottom: 0 },
};

export class HmgHotelDropdownElement extends Component {
  constructor() {
    super();
    this.state = {
      hmgmainList: [],
      hotelList: [],
      allHotels: false,
    };
  }

  async componentDidMount() {
    const result = await this.props.hmgmainGetHmgMain();
    this.setState({
      hmgmainList: result,
    });
  }

  loadHotelList = async (e) => {
    // await this.props.hmgHotelGet(e);

    const apiresponse = await this.props.projectGetHotels(e);

    let hotelList = [];
    hotelList = apiresponse.map((elem) => {
      return {
        id: elem._id,
        name: elem.hotel_name,
        hotel_code: elem.hotel_code,
      };
    });

    this.setState(
      {
        hotelList: hotelList,
      },
      () => {
        if (this.props.afterHotelLoad !== undefined) {
          this.props.afterHotelLoad();
        }
      }
    );
  };

  handleSelectChange = (e) => {
    this.props.setAllHotels(e.target.checked);
    console.log(e.target.checked, this.props.api.hmgGetData, "all select");
    if (e.target.checked && Array.isArray(this.state.hotelList)) {
      const hotels = this.state.hotelList;
      this.props.handleHotelChange(
        hotels.map(function (value) {
          return value.id;
        })
      );
    } else if (!e.target.checked) {
      this.props.handleHotelChange([]);
    }
    // this.setState({allHotels:e.target.checked},()=>{
    //     if (e.target.checked && this.props.api.hmgGetData!==null) {
    //         const hotels = this.state.hotelList;
    //         this.props.handleHotelChange(hotels.map(function (value) {
    //           return value.id;
    //         }));
    //     }
    // })
  };

  hotelChange = (e) => {
    this.props.handleHotelChange(e);
    if (
      this.props.multipleHotels !== undefined &&
      this.props.multipleHotels &&
      e.length != this.state.hotelList.length
    ) {
      // this.setState({allHotels:false});
      if (this.props.setAllHotels !== undefined) {
        this.props.setAllHotels(false);
      }
    }
  };

  hmgChange = (params) => {
    this.props.handleHmgChange(params);
    // this.setState({
    //     allHotels:false
    // })
    if (this.props.setAllHotels !== undefined) {
      this.props.setAllHotels(false);
    }
  };

  handleReplicateCheck = (e) => {
    this.setState({
      isreplicate: e.target.checked,
      replicateHotel: undefined,
    });
  };

  getReplicateHotelList = () => {
    const allocated_hotels = this.props.hmgHotelData
      .filter((rec) => rec.bulk_file_mapping.length > 0)
      .map((el) => el._id);
    return this.state.hotelList.filter((el) =>
      allocated_hotels.includes(el.id)
    );
  };

  getHotelList = () => {
    if (this.props.isreplicate) {
      const empty_hotels = this.props.hmgHotelData
        .filter((rec) => rec.bulk_file_mapping.length === 0)
        .map((el) => el._id);
      return this.state.hotelList.filter((el) => empty_hotels.includes(el.id));
    }
    return this.state.hotelList;
  };

  getProjectList = (e) => {
    const hmgselected = this.state.hmgmainList.find((el) => el._id === e);
    if (hmgselected !== undefined) {
      return hmgselected.projects;
    }
    return [];
  };

  render() {
    return (
      <div>
        <HmgMainDropdown
          hmgmainSelect={this.props.hmgmainSelect}
          hmgmainList={this.state.hmgmainList}
          hmgmainChange={this.props.hmgmainChange}
        />
        <HmgDropdown
          hmgStyles={hmgStylesWithoutMargin}
          hmgSelect={this.props.hmgSelect}
          handleHmgChange={this.hmgChange}
          loadHotelList={this.loadHotelList}
          projectList={this.getProjectList(this.props.hmgmainSelect)}
          removeReportSelect={
            this.props.removeReportSelect !== undefined &&
            this.props.removeReportSelect
              ? true
              : false
          }
        />
        {this.props.multipleHotels !== undefined &&
        this.props.multipleHotels &&
        this.props.hmgSelect !== undefined ? (
          <SelectAll
            selectStyles={selectStyles}
            allHotels={this.props.allhotelSelect}
            multiple={
              this.props.multipleHotels !== undefined &&
              this.props.multipleHotels
                ? true
                : false
            }
            handleSelectChange={this.handleSelectChange}
            disabled={this.props.isreplicate}
          />
        ) : null}
        {this.props.multipleHotels !== undefined &&
        this.props.multipleHotels &&
        this.props.hmgSelect !== undefined ? (
          <Form.Item {...repHotelStyles}>
            <Checkbox
              checked={this.props.isreplicate}
              onChange={this.props.handleReplicateCheck}
            >
              Replicate hotel
            </Checkbox>
          </Form.Item>
        ) : null}
        {this.props.isreplicate ? (
          <HotelDropdown
            key="replicatelist"
            hotelList={this.getReplicateHotelList()}
            handleHotelChange={this.props.handleReplicateHotel}
            hotelSelect={this.props.replicateHotel}
            label={""}
            hotelStyles={repHotelStyles}
          />
        ) : null}
        <HotelDropdown
          key="hotelList"
          hotelList={this.getHotelList()}
          handleHotelChange={this.hotelChange}
          hotelSelect={this.props.hotelSelect}
          multiple={
            this.props.multipleHotels !== undefined && this.props.multipleHotels
              ? true
              : false
          }
          label={
            typeof this.props.hotellabel === "string"
              ? this.props.hotellabel
              : "Hotel Name"
          }
          hotelStyles={hotelListStyles}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hmgGet: () => dispatch(hmgGet()),
    hmgHotelGet: (id) => dispatch(hmgHotels(id)),
    hmgmainGetHmgMain: () => dispatch(hmgmainGetHmgMain()),
    projectGetHotels: (id) => dispatch(projectGetHotels(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HmgHotelDropdownElement);
